import { AxiosResponse } from "axios";
import RequestUtilitario, { BasicQueryType } from "../../../../Utils/RequisicaoUtilitario";
import RegimeTributario from "../../../../Models/Financeiro/Faturamento/Imposto/RegimeTributario";
import { useQuery } from "@tanstack/react-query";
import { Axios } from "../../../Axios";

export function useListar({
    regimeTributario,
    ativo,
    queryKey,
    ...reset
}: BasicQueryType<AxiosResponse<RegimeTributario[]>, {
    regimeTributario?: RegimeTributario
    ativo?: boolean
}>) {
    const queryString = RequestUtilitario.objectToQueryString({
        ...regimeTributario ?? {},
        regimeTributarioAtivo : ativo
    });

    return useQuery({
        ...reset,
        queryKey: ["Financeiro.Faturamento.Imposto.RegimeTributario.Listar", `Financeiro.Faturamento.Imposto.RegimeTributario.Listar?${queryString}`],
        queryFn: () => Axios.get<RegimeTributario[]>(`financeiro/faturamento/imposto/RegimeTributario?${queryString}`),
        select : ({ data }) => {
            return data.map(m => {
                m.dataCriacao = new Date(m.dataCriacao);
                return m;
            });
        },
        staleTime: 1000 * 60 * 60 // query ficará valida por 1 hora
    });
}

export default {
    useListar
}